module.exports = __webpack_public_path__ + "static/media/bfile-annuties.96d46805.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/WizardInvitee/parts/images/bfile-annuties.svg
// module id = 1008
// module chunks = 0